import { NavLink, Outlet } from "react-router-dom";
import Container from "@/layout/Container";

const baseLinkClass =
  "px-3 py-2 rounded-xl border border-[rgb(var(--border-rgb))] bg-[rgb(var(--card-rgb))] text-sm transition-colors hover:bg-[rgb(var(--card-2-rgb))]";

const activeLinkClass =
  "border-[rgb(var(--primary-rgb))] bg-[rgb(var(--primary-rgb))] text-white";

// Panel Mayorista Slice B — el tab "Cuenta mayorista" se eliminó de acá.
// La solicitud/estado vive ahora en /wholesale (top-level), accesible desde
// el dropdown "Cuenta y listas" del Navbar. El redirect en AppRouter
// (account/wholesale → /wholesale) preserva bookmarks viejos.
export default function AccountLayout() {
  return (
    <Container className="py-8">
      <div className="mb-6 space-y-2">
        <h1 className="text-2xl font-bold tracking-tight">Mi cuenta</h1>
        <p className="text-sm text-[rgb(var(--muted-foreground-rgb))]">
          Gestiona tu información personal, direcciones, pedidos y seguridad.
        </p>
      </div>

      <div className="mb-6 flex flex-wrap gap-2">
        <NavLink
          to="profile"
          end
          className={({ isActive }) =>
            `${baseLinkClass} ${isActive ? activeLinkClass : ""}`
          }
        >
          Información personal
        </NavLink>

        <NavLink
          to="addresses"
          className={({ isActive }) =>
            `${baseLinkClass} ${isActive ? activeLinkClass : ""}`
          }
        >
          Direcciones de entrega
        </NavLink>

        <NavLink
          to="orders"
          className={({ isActive }) =>
            `${baseLinkClass} ${isActive ? activeLinkClass : ""}`
          }
        >
          Pedidos
        </NavLink>

        <NavLink
          to="security"
          className={({ isActive }) =>
            `${baseLinkClass} ${isActive ? activeLinkClass : ""}`
          }
        >
          Seguridad
        </NavLink>
      </div>

      <div className="rounded-2xl border border-[rgb(var(--border-rgb))] bg-[rgb(var(--card-rgb))] p-4 sm:p-5">
        <Outlet />
      </div>
    </Container>
  );
}
